import Vue from 'vue'
import VainWin from './VainWin.vue'
import store from '@/store/index'

export default class VainWinInstance {
  constructor(backgroundIndex) {
    // 创建一个 Vue 实例
    const VainWinConstructor = Vue.extend(VainWin)
    const instance = new VainWinConstructor({
      propsData: { backgroundIndex },
      store: store,  // 手动将 store 注入到实例中
    })

    // 挂载实例到一个新创建的 DOM 元素上
    instance.$mount()
    document.body.appendChild(instance.$el)
  }
}